import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyBundleUpgradeIcon = lazy(() => import('./svg-components/bundle-upgrade-icon'));

const BundleUpgradeIcon = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyBundleUpgradeIcon {...rest} />
  </Suspense>
);

export default BundleUpgradeIcon;
